import * as legendActions from '../../actions/legendActions';
import * as chartActionTypes from '../../constants/chart-action-types';
import * as utils from './legend.utils';

const initialState = {
  enabled: false,
  layout: 'default',
  showColorChips: true,
  itemsInOrder: false,
  mustRender: false,
};

function legendReducer(state = initialState, action) {
  const { payload, stateTree } = action;

  switch (action.type) {
    case chartActionTypes.DESTROY_CHART:
      return initialState;
    case legendActions.MUST_RENDER_FALSE:
      return { ...state, mustRender: payload };
    case chartActionTypes.RECEIVE_CHART:
      return utils.fetchLegendInfo(state, action);
    case legendActions.ENABLE_LEGEND:
      return utils.updateChart(stateTree, state, payload, 'enabled');
    case legendActions.UPDATE_LEGEND_LAYOUT:
      return utils.updateChart(stateTree, state, payload, 'layout');
    case legendActions.HIDE_COLOR_CHIPS:
      return utils.updateChart(stateTree, state, payload, 'showColorChips');
    case legendActions.ORDER_LEGEND_ITEMS:
      return utils.updateChart(stateTree, state, payload, 'itemsInOrder');
    default:
      return state;
  }
}

export default legendReducer;
